import {
  Box,
  BoxProps,
  CloseButton,
  useColorModeValue
} from "@chakra-ui/react";
import L from "leaflet";
import { useEffect, useRef } from "react";

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  zIndex?: number;
  heading?: React.ReactNode;
  direction?: "left" | "right";
  size?: number;
} & BoxProps;

export const SideAreaMap = ({
  children,
  isOpen,
  size = 25,
  direction = "left",
  onClose = () => null,
  zIndex = 0,
  ...props
}: Props) => {
  const bgColor = useColorModeValue("white", "gray.1000");
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      L.DomEvent.disableClickPropagation(containerRef.current);
      L.DomEvent.disableScrollPropagation(containerRef.current);
    }
  }, []);

  const directionsShift = {
    left: {
      positionLeft: (isOpen: boolean) => (isOpen ? "0" : `-${size}rem`),
      positionRight: () => "auto"
    },
    right: {
      positionLeft: () => "auto",
      positionRight: (isOpen: boolean) => (isOpen ? "0" : `-${size}rem`)
    }
  };

  return (
    <Box
      ref={containerRef}
      position="absolute"
      top="0"
      bottom="0"
      left={directionsShift[direction].positionLeft(isOpen)}
      right={directionsShift[direction].positionRight(isOpen)}
      w={`min(100%, ${size}rem)`}
      bg={bgColor}
      overflowY="auto"
      overflowX="hidden"
      transitionDuration="0.2s"
      zIndex={zIndex}
      px="6"
      py="6"
      boxShadow="sm"
      className="leaflet-control"
      {...props}
    >
      <CloseButton position="absolute" right="2" top="2" onClick={onClose} />
      {children}
    </Box>
  );
};
